import { Form } from "@/components/organisms/Form";
import ImgParent from "@/styles/assets/images/img_parent.png";
import { Buttons } from "@/components/atoms/Buttons";
import ImgChildren from "@/styles/assets/images/img_children.png";
import { typeState } from "@/common/states/agree";
import { useNavigate } from "react-router";
import { JoinTypeItem } from "@/components/atoms/JoinTypeItem";
import { JoinTemplate } from "@/components/templates/JoinTemplate";
import { useRecoilState } from "recoil";
import { JoinProcessBar } from "@/components/atoms/JoinProcessBar";
import { JoinTypeSelect } from "@/components/molecules/JoinTypeSelect";

export const JoinTypePage = () => {
  const navigate = useNavigate();
  const [type, setType] = useRecoilState(typeState);

  const joinType = [
    {
      id: 1,
      name: "type",
      value: 1,
      displayExpr: "학생 가입",
      text: <>초&middot;중학교 학생 가입</>,
      img: ImgChildren,
      defaultChecked: true,
    },
    {
      id: 2,
      name: "type",
      value: 2,
      displayExpr: "법정보호자 가입",
      text: <>초&middot;중학교 학생 보호자 가입</>,
      img: ImgParent,
    },
  ];

  return (
    <JoinTemplate>
      <Form
        processBar={<JoinProcessBar stepNow={1} stepTotal={6} />}
        title="회원가입 선택"
        text={
          <>
            법정보호자 가입만으로는 어플 사용이 불가합니다. <br />
            (법정보호자 가입은 선택 사항)
          </>
        }
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="다음"
            onClick={() => {
              navigate("/auth/join/agree-attend");
            }}
          />
        }
      >
        <JoinTypeSelect>
          <>
            {joinType.map((item: any, idx: number) => {
              return (
                <JoinTypeItem
                  data={item}
                  key={idx}
                  onChange={() => {
                    setType((prev) => ({
                      ...prev,
                      selectedType: item.id,
                    }));
                  }}
                  value={type?.selectedType}
                />
              );
            })}
          </>
        </JoinTypeSelect>
      </Form>
    </JoinTemplate>
  );
};
